import React, { useCallback, useState, useEffect } from "react";
import styled from "styled-components";
import TimeBar from "@components/TimeBar";
import playSound from "@/sound";
import GameScore from "@components/donutgame/GameScore";
import Basket from "@components/donutgame/Basket";
import Donuts from "@components/donutgame/Donuts";
import GameCompletePop from "@components/elements/GameCompletePop";
import { blockTouch, sleep, shuffle, randomRange } from "@stores/vars";
import { atom, useAtom } from "jotai";

const Wrap = styled.div`
  position: relative;
  height: 1200px;
  background: url(${require("@assets/img/donutgame/bg.jpg")}) no-repeat;
  z-index: 0;
`;

const TimeBarWrap = styled.div`
  position: absolute;
  left: 200px;
  top: 30px;
`;

const GameContainer = styled.div`
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
`;

const score_ = atom(0);
const currentItemInfo = atom({
  img: null,
  word: null,
  items: [],
});
const answerImg = atom([]);
let currentCount = 1;
let changeCount = 1;

window.__isTimeout = false;
const GameDonut = ({ data, endClick }) => {
  const [isStart, setStart] = useState(false);
  const [isComplete, setComplete] = useState(false);
  const [score, setScore] = useAtom(score_);
  const [answerDonuts, setAnswerDonuts] = useAtom(answerImg);
  // 도넛이 떨어지는 속도
  const [itemSpeed, setItemSpeed] = useState(4000);
  // 현재 문제
  const [currentItem, setCurrentItem] = useAtom(currentItemInfo);

  const timeOver = useCallback(() => {
    window.__isTimeout = true;
    playSound.wordStop();
    blockTouch();
    setAnswerDonuts([]);
    setCurrentItem({
      ...currentItem,
      items: [],
    });

    if (document.querySelector("#numCircle")) {
      document.querySelector("#numCircle").style.opacity = 0;
    }
    setComplete(true);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 현재 문제(단어를 고름)
  const pickWord = (isCorrect = false) => {
    if (window.__isTimeout) return;

    const { word } = currentItem;
    const isTwo = randomRange(0, 1) === 0;

    // 변경 타이밍이면 정답 단어 다른 단어로 변경
    if (currentCount >= changeCount && isCorrect) {
      currentCount = 1;
      const pick = shuffle(data.data.resources)[0];
      const word = pick.word;
      const img = pick.img;
      // 정답을 고르고
      const answerItem = data.data.resources.filter(
        (item) => item.word === word
      )[0];
      // 나머지는 랜덤으로
      const ranItem = shuffle(
        data.data.resources.filter((item) => item.word !== word)
      ).slice(0, isTwo ? 1 : 2);
      // 위에서 뽑은 요소를 랜덤으로 섞는다.
      const items = shuffle([answerItem, ...ranItem]);
      setCurrentItem({
        ...currentItem,
        img: img,
        word: word,
        items: items,
      });
    } else {
      // 아니면 그냥 유지..
      // 정답을 고르고
      const answerItem = data.data.resources.filter(
        (item) => item.word === word
      )[0];
      // 나머지는 랜덤으로
      const ranItem = shuffle(
        data.data.resources.filter((item) => item.word !== word)
      ).slice(0, isTwo ? 1 : 2);
      // 위에서 뽑은 요소를 랜덤으로 섞는다.
      const items = shuffle([answerItem, ...ranItem]);

      if (isCorrect) {
        currentCount += 1;
      }

      setCurrentItem({
        ...currentItem,
        items: items,
      });
    }
  };

  // 정답!
  const onSuccessDonut = (img, sound) => {
    playSound.word(sound);
    const before = [...answerDonuts];
    before.push(img);
    setAnswerDonuts(before);
    window.__cardGameEffectFunc(true);
    setScore(score + 1);
    pickWord(true);
    blockTouch(false);
  };

  // 오탑
  const onFail = () => {
    window.__cardGameEffectFunc(false);
    pickWord(false);
    blockTouch(false);
  };

  useEffect(() => {
    if (isStart) {
      if (document.querySelector("#numCircle")) {
        document.querySelector("#numCircle").style.opacity = 0;
      }
      currentCount = 1;
      changeCount = 1;
      setAnswerDonuts([]);
      setScore(0);
      pickWord(true);
    } else {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isStart]);

  useEffect(() => {
    playSound.bgm(require("@assets/sounds/bgm/donut.mp3"));
    setStart(true);
    return () => {
      playSound.wordStop();
      window.__isTimeout = false;
      setScore(0);
      currentCount = 1;
      changeCount = 1;

      setAnswerDonuts([]);
      setCurrentItem({
        img: null,
        word: null,
        items: [],
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Wrap>
      <TimeBarWrap>
        <TimeBar
          isStart={isStart}
          total={60}
          onSuccess={timeOver}
          cName="donut"
        />
      </TimeBarWrap>
      <GameScore score={score} />
      <GameContainer>
        {currentItem.word !== "" && currentItem.items.length > 0 && (
          <Donuts
            isStart={isStart}
            speed={itemSpeed}
            onSuccess={onSuccessDonut}
            onFail={onFail}
            answerWord={currentItem.word}
            data={currentItem.items}
            categoryKey={data.categoryKey}
          />
        )}

        <Basket
          currentWord={currentItem.word}
          currentImg={currentItem.img}
          answerImgs={answerDonuts}
          isComplete={isComplete}
        />
      </GameContainer>
      {isComplete && (
        <GameCompletePop
          score={score}
          onRestartClick={() => {
            window.__isTimeout = false;
            setComplete(false);
            setStart(false);
            sleep(500).then(() => {
              setStart(true);
            });
          }}
          onEndClick={endClick}
        />
      )}
    </Wrap>
  );
};

export default GameDonut;
